function Header() {
  return (
    <header>
      <img alt="about" src={require('../img/bsu.jpg')} className="img-header"/>
      <h1>Восьмые Богдановские чтения по дифференциальным уравнениям</h1>
      <h2>Международная математическая конференция</h2>
      <h2>Минск, 2 - 5 декабря 2025 года</h2>
      <div className="headerbg"></div>
    </header>
  );
}
export default Header;
